export const convertingApplicationEmail = (data: { email: string | null }[]) => {
  let text = '';
  data.forEach((item) => {
    if (item.email) {
      text += `${item.email};`;
    }
  });
  return text;
};
